// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================================================
   FlowBuilder - Typebot-like Sidebar + Premium UI
   ========================================================= */

/* Canvas */
.flow-canvas-container {
  background-color: #f8fafc;
  background-image: radial-gradient(rgba(15, 23, 42, 0.12) 1px, transparent 1px);
  background-size: 18px 18px;
  width: 100%;
  height: 100%;
  flex: 1 1;
  min-width: 0;
}

.dark .flow-canvas-container {
  background-color: #0f172a;
  background-image: radial-gradient(rgba(148, 163, 184, 0.2) 1px, transparent 1px);
}

/* React Flow - controls/minimap */
.react-flow__controls {
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
}

.react-flow__controls-button {
  background: #ffffff;
  border: none;
  color: #111827;
}

.dark .react-flow__controls {
  border-color: #334155;
}

.dark .react-flow__controls-button {
  background: #0b1220;
  color: #e5e7eb;
}

.react-flow__controls-button:hover {
  background: #f9fafb;
}

.dark .react-flow__controls-button:hover {
  background: #1e293b;
}

.react-flow__minimap {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
}

.dark .react-flow__minimap {
  border-color: #334155;
}

.react-flow__node.selected > div {
  outline: 2px solid rgba(99, 102, 241, 0.28);
  outline-offset: 2px;
}

/* =========================================================
   Sidebar (Typebot-like)
   ========================================================= */
.flowbuilder-sidebar {
  /* Align full height with the flow canvas */
  position: relative;
  top: 0;
  align-self: stretch;
  height: 100%;
  max-height: none;
  overflow: auto;

  width: 272px;
  flex: 0 0 272px;

  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(17, 24, 39, 0.08);
  border-radius: 14px;
  box-shadow: 0 10px 28px rgba(16, 24, 40, 0.08);

  padding: 10px;

  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto,
    Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.dark .flowbuilder-sidebar {
  background: rgba(15, 23, 42, 0.96);
  border-color: rgba(148, 163, 184, 0.22);
  box-shadow: 0 10px 28px rgba(2, 6, 23, 0.45);
}

.flowbuilder-sidebar::-webkit-scrollbar { width: 10px; }
.flowbuilder-sidebar::-webkit-scrollbar-thumb {
  background: rgba(15, 23, 42, 0.10);
  border-radius: 999px;
  border: 3px solid transparent;
  background-clip: content-box;
}
.flowbuilder-sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(15, 23, 42, 0.18);
  border: 3px solid transparent;
  background-clip: content-box;
}

/* Top: Search + lock */
.flowbuilder-sidebar__top{
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
}

.flowbuilder-sidebar__search{
  flex: 1 1;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.10);
  background: #ffffff;
  padding: 0 12px;
  outline: none;
  font-size: 13px;
  color: #0f172a;
}

.dark .flowbuilder-sidebar__search{
  border-color: rgba(148, 163, 184, 0.3);
  background: #0b1220;
  color: #e5e7eb;
}

.flowbuilder-sidebar__search::placeholder{
  color: rgba(15, 23, 42, 0.45);
}

.dark .flowbuilder-sidebar__search::placeholder{
  color: rgba(226, 232, 240, 0.55);
}

.flowbuilder-sidebar__search:focus{
  border-color: rgba(99, 102, 241, 0.35);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.flowbuilder-sidebar__lock{
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.10);
  background: #ffffff;
  color: rgba(15, 23, 42, 0.55);
  cursor: not-allowed;
}

.dark .flowbuilder-sidebar__lock{
  border-color: rgba(148, 163, 184, 0.3);
  background: #0b1220;
  color: rgba(226, 232, 240, 0.65);
}

/* Sections */
.flowbuilder-sidebar__section{
  margin-bottom: 10px;
}

.flowbuilder-sidebar__title {
  font-size: 11px;
  font-weight: 600; /* lighter than before */
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(15, 23, 42, 0.55);
  margin: 4px 6px 8px;
}

.dark .flowbuilder-sidebar__title {
  color: rgba(226, 232, 240, 0.72);
}

/* Grid of chips (Typebot-like) */
.flowbuilder-sidebar__grid{
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 0 2px;
}

.flowbuilder-sidebar__chip{
  display: flex;
  align-items: center;
  gap: 8px;

  height: 34px;
  padding: 0 9px;

  border-radius: 10px;
  background: #ffffff;
  border: 1px solid rgba(17, 24, 39, 0.10);

  color: #0f172a;
  cursor: pointer;
  text-align: left;

  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;
}

.flowbuilder-sidebar__chip:hover{
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.10);
  border-color: rgba(99, 102, 241, 0.28);
}

.flowbuilder-sidebar__chip:disabled{
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.flowbuilder-sidebar__chipIcon{
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
}

.flowbuilder-sidebar__chipLabel{
  font-size: 12px;
  font-weight: 500; /* no bold */
  line-height: 1;
  color: rgba(15, 23, 42, 0.85);
}

.flowbuilder-mobile-fab {
  position: fixed;
  right: 18px;
  bottom: 18px;
  width: 54px;
  height: 54px;
  border-radius: 999px;
  border: 0;
  background: #2563eb;
  color: #ffffff;
  font-size: 34px;
  line-height: 1;
  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.42);
  z-index: 1301;
  display: none;
}

.flowbuilder-mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(2, 6, 23, 0.46);
  z-index: 1302;
  display: flex;
  justify-content: flex-start;
}

.flowbuilder-mobile-sheet {
  width: min(86vw, 320px);
  height: 100%;
  background: #ffffff;
  border-right: 1px solid rgba(17, 24, 39, 0.1);
  display: flex;
  flex-direction: column;
}

.flowbuilder-mobile-sheet__header {
  height: 52px;
  min-height: 52px;
  padding: 0 12px;
  border-bottom: 1px solid rgba(17, 24, 39, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
}

.flowbuilder-mobile-sheet__close {
  border: 1px solid rgba(17, 24, 39, 0.12);
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font-size: 12px;
  height: 30px;
  padding: 0 10px;
}

.flowbuilder-sidebar-mobile {
  height: 100%;
  overflow: auto;
  padding: 10px;
}

.fb-active-toggle-wrap {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
}

.fb-active-toggle-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  min-width: 52px;
  text-align: right;
}

.fb-active-toggle-label.is-active {
  color: #15803d;
}

.fb-active-toggle-label.is-inactive {
  color: #b91c1c;
}

.fb-active-toggle {
  position: relative;
  width: 46px;
  height: 26px;
  border: 0;
  border-radius: 999px;
  background: #cbd5e1;
  cursor: pointer;
  padding: 0;
  transition: background 180ms ease;
}

.fb-active-toggle:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.fb-active-toggle.is-on {
  background: #22c55e;
}

.fb-active-toggle.is-off {
  background: #94a3b8;
}

.fb-active-toggle-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.24);
  transition: transform 180ms ease;
}

.fb-active-toggle.is-on .fb-active-toggle-knob {
  transform: translateX(20px);
}

.fb-sim-chat {
  flex: 1 1;
  overflow-y: auto;
  background-color: #efeae2;
  background-image:
    radial-gradient(rgba(255, 255, 255, 0.55) 1px, transparent 1px),
    radial-gradient(rgba(0, 0, 0, 0.04) 1px, transparent 1px);
  background-position: 0 0, 12px 12px;
  background-size: 24px 24px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  padding: 14px;
}

.fb-sim-modal-paper {
  border-radius: 16px !important;
  overflow: hidden;
}

.fb-sim-modal-title {
  position: relative;
  background: #f8fafc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.07);
  padding: 14px 16px !important;
}

.fb-sim-title-text {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.fb-sim-close-btn {
  position: absolute !important;
  right: 10px;
  top: 10px;
}

.fb-sim-modal-content {
  height: 62vh;
  display: flex;
  flex-direction: column;
  padding: 12px !important;
}

.fb-sim-row {
  display: flex;
  margin-bottom: 8px;
}

.fb-sim-row--bot {
  justify-content: flex-start;
}

.fb-sim-row--user {
  justify-content: flex-end;
}

.fb-sim-row--system {
  justify-content: center;
}

.fb-sim-bubble {
  max-width: 78%;
  padding: 8px 10px;
  border-radius: 10px;
  white-space: pre-wrap;
  font-size: 12px;
  line-height: 1.45;
}

.fb-sim-bubble--bot {
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.1);
  color: #0f172a;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.fb-sim-bubble--user {
  background: #d9fdd3;
  color: #0f172a;
  border: 1px solid rgba(34, 197, 94, 0.2);
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.fb-sim-bubble--system {
  background: rgba(226, 232, 240, 0.95);
  color: #475569;
  font-size: 11px;
}

.fb-sim-input-row {
  margin-top: 10px;
  display: flex;
  gap: 8px;
  align-items: center;
}

.fb-sim-textfield .MuiOutlinedInput-root {
  border-radius: 28px;
  background: #ffffff;
}

.fb-sim-send-btn {
  border-radius: 999px !important;
  text-transform: none !important;
  font-weight: 700 !important;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.28) !important;
  min-width: 108px !important;
}

.fb-sim-send-btn:hover {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;
}

.fb-sim-actions {
  border-top: 1px solid rgba(15, 23, 42, 0.07);
  background: #f8fafc;
}

.fb-sim-restart-btn {
  text-transform: none !important;
  font-weight: 600 !important;
}

.fb-sim-empty-state {
  height: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: rgba(15, 23, 42, 0.65);
  font-size: 14px;
  font-weight: 600;
  padding: 0 20px;
}

/* Hide on small screens */
@media (max-width: 980px) {
  .flowbuilder-sidebar {
    display: none;
  }

  .flowbuilder-mobile-fab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

/* =========================================================
   Nodes (Premium) - used by message/menu/openai nodes
   ========================================================= */
.fb-node{
  width: 250px;
  position: relative;

  background: rgba(255,255,255,0.96);
  border: 1px solid rgba(17, 24, 39, 0.10);
  border-radius: 16px;
  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.10);

  padding: 12px;
  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;

  font-family: Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto,
    Arial, "Noto Sans", "Liberation Sans", sans-serif;
}

.fb-node:hover{
  transform: translateY(-1px);
  box-shadow: 0 18px 46px rgba(16, 24, 40, 0.14);
  border-color: rgba(99, 102, 241, 0.28);
}

.react-flow__node.selected .fb-node{
  outline: 2px solid rgba(99, 102, 241, 0.28);
  outline-offset: 2px;
}

.fb-node__header{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 56px;
  margin-bottom: 8px;
}

.fb-node__chip{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 999px;

  background: rgba(99, 102, 241, 0.10);
  border: 1px solid rgba(99, 102, 241, 0.18);
  color: #0f172a;
  font-size: 13px;
  font-weight: 600; /* lighter */
}

.fb-node__body{
  color: rgba(15, 23, 42, 0.75);
  font-size: 12.5px;
  line-height: 1.35;
  padding-right: 6px;
}

/* Actions (top-right) */
.fb-node__actions{
  position: absolute;
  right: 10px;
  top: 10px;
  display: flex;
  gap: 6px;
}

.fb-iconbtn{
  width: 30px;
  height: 30px;
  border-radius: 10px;
  border: 1px solid rgba(17, 24, 39, 0.08);
  background: rgba(255,255,255,0.92);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: rgba(15, 23, 42, 0.55);
  transition: background 120ms ease, transform 120ms ease, color 120ms ease,
    border-color 120ms ease;
}

.fb-iconbtn:hover{
  background: #ffffff;
  color: rgba(15, 23, 42, 0.80);
  border-color: rgba(99, 102, 241, 0.22);
  transform: translateY(-1px);
}

/* Handles */
.fb-handle{
  width: 18px !important;
  height: 18px !important;
  border-radius: 999px !important;
  background: #6366F1 !important;
  border: 2px solid #ffffff !important;
  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.28);
  cursor: pointer;
}

.fb-handle__arrow{
  color: #ffffff;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  margin-bottom: 1px;
  pointer-events: none;
}


/* =========================================================
   Workspace alignment (Sidebar + Canvas)
   ========================================================= */
.fb-workspace{
  align-items: stretch;
  gap: 10px;
  min-height: 75vh;
}

/* Ensure canvas and sidebar share the same vertical span */
.flow-canvas-container{
  border-radius: 14px;
  border: 1px solid rgba(17, 24, 39, 0.06);
  box-shadow: 0 10px 26px rgba(16, 24, 40, 0.06);
  overflow: hidden;
}

/* =========================================================
   Header polish (Title + Buttons)
   ========================================================= */
.fb-headerbar{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(17, 24, 39, 0.08);
  border-radius: 14px;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);
}

.fb-header-left{
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.fb-header-left > *:first-child{
  /* Title component */
  margin: 0;
}

.fb-header-subtitle{
  font-size: 12px;
  font-weight: 400;
  color: rgba(15, 23, 42, 0.62);
}

.fb-header-actions{
  display: flex;
  gap: 8px;
}

/* Buttons (Material-UI v4) */
.fb-header-btn{
  border-radius: 10px !important;
  padding: 7px 12px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  box-shadow: 0 8px 16px rgba(16, 24, 40, 0.10) !important;
  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease !important;
}

.fb-header-btn:hover{
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(16, 24, 40, 0.14) !important;
  filter: brightness(1.02);
}

@media (max-width: 1160px) {
  .fb-headerbar {
    flex-direction: column;
    align-items: flex-start;
  }

  .fb-header-actions {
    width: 100%;
    flex-wrap: wrap;
  }
}

/* Optional: color accents without changing your theme primary */
.fb-btn-import{ }
.fb-btn-export{ }
.fb-btn-save{ }

/* =========================================================
   Part 2 - Node Compact System (SaaS)
   ========================================================= */
.react-flow__node-message > div,
.react-flow__node-menu > div,
.react-flow__node-interval > div,
.react-flow__node-img > div,
.react-flow__node-audio > div,
.react-flow__node-video > div,
.react-flow__node-randomizer > div,
.react-flow__node-singleBlock > div,
.react-flow__node-ticket > div,
.react-flow__node-typebot > div,
.react-flow__node-openai > div,
.react-flow__node-question > div,
.react-flow__node-start > div {
  padding: 10px !important;
  border-radius: 12px !important;
  border: 1px solid rgba(15, 23, 42, 0.1) !important;
  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.09) !important;
  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease !important;
}

.react-flow__node-message > div:hover,
.react-flow__node-menu > div:hover,
.react-flow__node-interval > div:hover,
.react-flow__node-img > div:hover,
.react-flow__node-audio > div:hover,
.react-flow__node-video > div:hover,
.react-flow__node-randomizer > div:hover,
.react-flow__node-singleBlock > div:hover,
.react-flow__node-ticket > div:hover,
.react-flow__node-typebot > div:hover,
.react-flow__node-openai > div:hover,
.react-flow__node-question > div:hover,
.react-flow__node-start > div:hover {
  transform: translateY(-1px);
  border-color: rgba(99, 102, 241, 0.26) !important;
  box-shadow: 0 12px 26px rgba(16, 24, 40, 0.12) !important;
}

.react-flow__node-message > div,
.react-flow__node-menu > div,
.react-flow__node-interval > div,
.react-flow__node-randomizer > div,
.react-flow__node-ticket > div,
.react-flow__node-typebot > div,
.react-flow__node-openai > div,
.react-flow__node-question > div,
.react-flow__node-start > div {
  width: 200px !important;
}

.react-flow__node-singleBlock > div,
.react-flow__node-img > div,
.react-flow__node-audio > div,
.react-flow__node-video > div {
  width: 220px !important;
}

.react-flow__node-message > div .MuiSvgIcon-root,
.react-flow__node-menu > div .MuiSvgIcon-root,
.react-flow__node-interval > div .MuiSvgIcon-root,
.react-flow__node-img > div .MuiSvgIcon-root,
.react-flow__node-audio > div .MuiSvgIcon-root,
.react-flow__node-video > div .MuiSvgIcon-root,
.react-flow__node-randomizer > div .MuiSvgIcon-root,
.react-flow__node-singleBlock > div .MuiSvgIcon-root,
.react-flow__node-ticket > div .MuiSvgIcon-root,
.react-flow__node-typebot > div .MuiSvgIcon-root,
.react-flow__node-openai > div .MuiSvgIcon-root,
.react-flow__node-question > div .MuiSvgIcon-root,
.react-flow__node-start > div .MuiSvgIcon-root {
  width: 15px;
  height: 15px;
}

.react-flow__node-message > div [style*="fontSize: 14"],
.react-flow__node-menu > div [style*="fontSize: 14"],
.react-flow__node-interval > div [style*="fontSize: 14"],
.react-flow__node-randomizer > div [style*="fontSize: 14"],
.react-flow__node-singleBlock > div [style*="fontSize: 14"],
.react-flow__node-ticket > div [style*="fontSize: 14"],
.react-flow__node-typebot > div [style*="fontSize: 14"],
.react-flow__node-openai > div [style*="fontSize: 14"],
.react-flow__node-question > div [style*="fontSize: 14"],
.react-flow__node-start > div [style*="fontSize: 14"] {
  font-size: 13px !important;
}

.react-flow__node-message > div [style*="fontSize: 12"],
.react-flow__node-menu > div [style*="fontSize: 12"],
.react-flow__node-interval > div [style*="fontSize: 12"],
.react-flow__node-randomizer > div [style*="fontSize: 12"],
.react-flow__node-singleBlock > div [style*="fontSize: 12"],
.react-flow__node-ticket > div [style*="fontSize: 12"],
.react-flow__node-typebot > div [style*="fontSize: 12"],
.react-flow__node-openai > div [style*="fontSize: 12"],
.react-flow__node-question > div [style*="fontSize: 12"],
.react-flow__node-start > div [style*="fontSize: 12"] {
  font-size: 11px !important;
}

.react-flow__node-message > div .react-flow__handle,
.react-flow__node-menu > div .react-flow__handle,
.react-flow__node-interval > div .react-flow__handle,
.react-flow__node-img > div .react-flow__handle,
.react-flow__node-audio > div .react-flow__handle,
.react-flow__node-video > div .react-flow__handle,
.react-flow__node-randomizer > div .react-flow__handle,
.react-flow__node-singleBlock > div .react-flow__handle,
.react-flow__node-ticket > div .react-flow__handle,
.react-flow__node-typebot > div .react-flow__handle,
.react-flow__node-openai > div .react-flow__handle,
.react-flow__node-question > div .react-flow__handle,
.react-flow__node-start > div .react-flow__handle {
  width: 16px !important;
  height: 16px !important;
  border: 2px solid #ffffff !important;
  box-shadow: 0 8px 18px rgba(99, 102, 241, 0.24) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.react-flow__node-message > div audio,
.react-flow__node-video > div video,
.react-flow__node-img > div img {
  border-radius: 10px;
}

.react-flow__node-message > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-menu > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-interval > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-img > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-audio > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-video > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-randomizer > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-singleBlock > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-ticket > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-typebot > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-openai > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-question > div .react-flow__handle .MuiSvgIcon-root,
.react-flow__node-start > div .react-flow__handle .MuiSvgIcon-root {
  width: 9px !important;
  height: 9px !important;
  margin: 0 !important;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FlowBuilderConfig/flowbuilder.css"],"names":[],"mappings":"AAAA;;8DAE8D;;AAE9D,WAAW;AACX;EACE,yBAAyB;EACzB,8EAA8E;EAC9E,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gFAAgF;AAClF;;AAEA,kCAAkC;AAClC;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;8DAE8D;AAC9D;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,MAAM;EACN,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;;EAEd,YAAY;EACZ,eAAe;;EAEf,qCAAqC;EACrC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;;EAE9C,aAAa;;EAEb;qDACmD;AACrD;;AAEA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA,0CAA0C,WAAW,EAAE;AACvD;EACE,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,wBAAwB;EAC1C,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;;EAER,YAAY;EACZ,cAAc;;EAEd,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;;EAExC,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB,EAAE,YAAY;EAC9B,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,+CAA+C;EAC/C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB;;6DAE2D;EAC3D,mCAAmC;EACnC,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAC3B,wEAAwE;EACxE,yBAAyB;EACzB,0DAA0D;EAC1D,2BAA2B;AAC7B;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,YAAY;EACZ,kBAAkB;;EAElB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;;EAE9C,aAAa;EACb,gFAAgF;;EAEhF;qDACmD;AACrD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;;EAEpB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,eAAe;EACf,gBAAgB,EAAE,YAAY;AAChC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B;2BACyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA,YAAY;AACZ;EACE,sBAAsB;EACtB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;8DAE8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;EACxC,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,6BAA6B;AAC7B;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,wDAAwD;EACxD,qFAAqF;AACvF;;AAEA;EACE,2BAA2B;EAC3B,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA,gEAAgE;AAChE,gBAAgB;AAChB,gBAAgB;AAChB,cAAc;;AAEd;;8DAE8D;AAC9D;;;;;;;;;;;;;EAaE,wBAAwB;EACxB,8BAA8B;EAC9B,kDAAkD;EAClD,wDAAwD;EACxD,2FAA2F;AAC7F;;AAEA;;;;;;;;;;;;;EAaE,2BAA2B;EAC3B,iDAAiD;EACjD,yDAAyD;AAC3D;;AAEA;;;;;;;;;EASE,uBAAuB;AACzB;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;;;;;;;;;;;;EAaE,WAAW;EACX,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;EAUE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;EAaE,sBAAsB;EACtB,uBAAuB;EACvB,oCAAoC;EACpC,0DAA0D;EAC1D,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;EAaE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;AAC3B","sourcesContent":["/* =========================================================\n   FlowBuilder - Typebot-like Sidebar + Premium UI\n   ========================================================= */\n\n/* Canvas */\n.flow-canvas-container {\n  background-color: #f8fafc;\n  background-image: radial-gradient(rgba(15, 23, 42, 0.12) 1px, transparent 1px);\n  background-size: 18px 18px;\n  width: 100%;\n  height: 100%;\n  flex: 1;\n  min-width: 0;\n}\n\n.dark .flow-canvas-container {\n  background-color: #0f172a;\n  background-image: radial-gradient(rgba(148, 163, 184, 0.2) 1px, transparent 1px);\n}\n\n/* React Flow - controls/minimap */\n.react-flow__controls {\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.react-flow__controls-button {\n  background: #ffffff;\n  border: none;\n  color: #111827;\n}\n\n.dark .react-flow__controls {\n  border-color: #334155;\n}\n\n.dark .react-flow__controls-button {\n  background: #0b1220;\n  color: #e5e7eb;\n}\n\n.react-flow__controls-button:hover {\n  background: #f9fafb;\n}\n\n.dark .react-flow__controls-button:hover {\n  background: #1e293b;\n}\n\n.react-flow__minimap {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);\n}\n\n.dark .react-flow__minimap {\n  border-color: #334155;\n}\n\n.react-flow__node.selected > div {\n  outline: 2px solid rgba(99, 102, 241, 0.28);\n  outline-offset: 2px;\n}\n\n/* =========================================================\n   Sidebar (Typebot-like)\n   ========================================================= */\n.flowbuilder-sidebar {\n  /* Align full height with the flow canvas */\n  position: relative;\n  top: 0;\n  align-self: stretch;\n  height: 100%;\n  max-height: none;\n  overflow: auto;\n\n  width: 272px;\n  flex: 0 0 272px;\n\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 10px 28px rgba(16, 24, 40, 0.08);\n\n  padding: 10px;\n\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto,\n    Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.dark .flowbuilder-sidebar {\n  background: rgba(15, 23, 42, 0.96);\n  border-color: rgba(148, 163, 184, 0.22);\n  box-shadow: 0 10px 28px rgba(2, 6, 23, 0.45);\n}\n\n.flowbuilder-sidebar::-webkit-scrollbar { width: 10px; }\n.flowbuilder-sidebar::-webkit-scrollbar-thumb {\n  background: rgba(15, 23, 42, 0.10);\n  border-radius: 999px;\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n.flowbuilder-sidebar::-webkit-scrollbar-thumb:hover {\n  background: rgba(15, 23, 42, 0.18);\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n\n/* Top: Search + lock */\n.flowbuilder-sidebar__top{\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.flowbuilder-sidebar__search{\n  flex: 1;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  background: #ffffff;\n  padding: 0 12px;\n  outline: none;\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.dark .flowbuilder-sidebar__search{\n  border-color: rgba(148, 163, 184, 0.3);\n  background: #0b1220;\n  color: #e5e7eb;\n}\n\n.flowbuilder-sidebar__search::placeholder{\n  color: rgba(15, 23, 42, 0.45);\n}\n\n.dark .flowbuilder-sidebar__search::placeholder{\n  color: rgba(226, 232, 240, 0.55);\n}\n\n.flowbuilder-sidebar__search:focus{\n  border-color: rgba(99, 102, 241, 0.35);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.flowbuilder-sidebar__lock{\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  background: #ffffff;\n  color: rgba(15, 23, 42, 0.55);\n  cursor: not-allowed;\n}\n\n.dark .flowbuilder-sidebar__lock{\n  border-color: rgba(148, 163, 184, 0.3);\n  background: #0b1220;\n  color: rgba(226, 232, 240, 0.65);\n}\n\n/* Sections */\n.flowbuilder-sidebar__section{\n  margin-bottom: 10px;\n}\n\n.flowbuilder-sidebar__title {\n  font-size: 11px;\n  font-weight: 600; /* lighter than before */\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(15, 23, 42, 0.55);\n  margin: 4px 6px 8px;\n}\n\n.dark .flowbuilder-sidebar__title {\n  color: rgba(226, 232, 240, 0.72);\n}\n\n/* Grid of chips (Typebot-like) */\n.flowbuilder-sidebar__grid{\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  padding: 0 2px;\n}\n\n.flowbuilder-sidebar__chip{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n\n  height: 34px;\n  padding: 0 9px;\n\n  border-radius: 10px;\n  background: #ffffff;\n  border: 1px solid rgba(17, 24, 39, 0.10);\n\n  color: #0f172a;\n  cursor: pointer;\n  text-align: left;\n\n  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease;\n}\n\n.flowbuilder-sidebar__chip:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 10px 24px rgba(16, 24, 40, 0.10);\n  border-color: rgba(99, 102, 241, 0.28);\n}\n\n.flowbuilder-sidebar__chip:disabled{\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.flowbuilder-sidebar__chipIcon{\n  display: inline-flex;\n  width: 24px;\n  height: 24px;\n  align-items: center;\n  justify-content: center;\n}\n\n.flowbuilder-sidebar__chipLabel{\n  font-size: 12px;\n  font-weight: 500; /* no bold */\n  line-height: 1;\n  color: rgba(15, 23, 42, 0.85);\n}\n\n.flowbuilder-mobile-fab {\n  position: fixed;\n  right: 18px;\n  bottom: 18px;\n  width: 54px;\n  height: 54px;\n  border-radius: 999px;\n  border: 0;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 34px;\n  line-height: 1;\n  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.42);\n  z-index: 1301;\n  display: none;\n}\n\n.flowbuilder-mobile-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(2, 6, 23, 0.46);\n  z-index: 1302;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.flowbuilder-mobile-sheet {\n  width: min(86vw, 320px);\n  height: 100%;\n  background: #ffffff;\n  border-right: 1px solid rgba(17, 24, 39, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.flowbuilder-mobile-sheet__header {\n  height: 52px;\n  min-height: 52px;\n  padding: 0 12px;\n  border-bottom: 1px solid rgba(17, 24, 39, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 13px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.flowbuilder-mobile-sheet__close {\n  border: 1px solid rgba(17, 24, 39, 0.12);\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font-size: 12px;\n  height: 30px;\n  padding: 0 10px;\n}\n\n.flowbuilder-sidebar-mobile {\n  height: 100%;\n  overflow: auto;\n  padding: 10px;\n}\n\n.fb-active-toggle-wrap {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin-right: 10px;\n}\n\n.fb-active-toggle-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n  min-width: 52px;\n  text-align: right;\n}\n\n.fb-active-toggle-label.is-active {\n  color: #15803d;\n}\n\n.fb-active-toggle-label.is-inactive {\n  color: #b91c1c;\n}\n\n.fb-active-toggle {\n  position: relative;\n  width: 46px;\n  height: 26px;\n  border: 0;\n  border-radius: 999px;\n  background: #cbd5e1;\n  cursor: pointer;\n  padding: 0;\n  transition: background 180ms ease;\n}\n\n.fb-active-toggle:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.fb-active-toggle.is-on {\n  background: #22c55e;\n}\n\n.fb-active-toggle.is-off {\n  background: #94a3b8;\n}\n\n.fb-active-toggle-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #ffffff;\n  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.24);\n  transition: transform 180ms ease;\n}\n\n.fb-active-toggle.is-on .fb-active-toggle-knob {\n  transform: translateX(20px);\n}\n\n.fb-sim-chat {\n  flex: 1;\n  overflow-y: auto;\n  background-color: #efeae2;\n  background-image:\n    radial-gradient(rgba(255, 255, 255, 0.55) 1px, transparent 1px),\n    radial-gradient(rgba(0, 0, 0, 0.04) 1px, transparent 1px);\n  background-position: 0 0, 12px 12px;\n  background-size: 24px 24px;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  border-radius: 12px;\n  padding: 14px;\n}\n\n.fb-sim-modal-paper {\n  border-radius: 16px !important;\n  overflow: hidden;\n}\n\n.fb-sim-modal-title {\n  position: relative;\n  background: #f8fafc;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.07);\n  padding: 14px 16px !important;\n}\n\n.fb-sim-title-text {\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.fb-sim-close-btn {\n  position: absolute !important;\n  right: 10px;\n  top: 10px;\n}\n\n.fb-sim-modal-content {\n  height: 62vh;\n  display: flex;\n  flex-direction: column;\n  padding: 12px !important;\n}\n\n.fb-sim-row {\n  display: flex;\n  margin-bottom: 8px;\n}\n\n.fb-sim-row--bot {\n  justify-content: flex-start;\n}\n\n.fb-sim-row--user {\n  justify-content: flex-end;\n}\n\n.fb-sim-row--system {\n  justify-content: center;\n}\n\n.fb-sim-bubble {\n  max-width: 78%;\n  padding: 8px 10px;\n  border-radius: 10px;\n  white-space: pre-wrap;\n  font-size: 12px;\n  line-height: 1.45;\n}\n\n.fb-sim-bubble--bot {\n  background: #ffffff;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  color: #0f172a;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n}\n\n.fb-sim-bubble--user {\n  background: #d9fdd3;\n  color: #0f172a;\n  border: 1px solid rgba(34, 197, 94, 0.2);\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);\n}\n\n.fb-sim-bubble--system {\n  background: rgba(226, 232, 240, 0.95);\n  color: #475569;\n  font-size: 11px;\n}\n\n.fb-sim-input-row {\n  margin-top: 10px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.fb-sim-textfield .MuiOutlinedInput-root {\n  border-radius: 28px;\n  background: #ffffff;\n}\n\n.fb-sim-send-btn {\n  border-radius: 999px !important;\n  text-transform: none !important;\n  font-weight: 700 !important;\n  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%) !important;\n  color: #ffffff !important;\n  box-shadow: 0 10px 20px rgba(34, 197, 94, 0.28) !important;\n  min-width: 108px !important;\n}\n\n.fb-sim-send-btn:hover {\n  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%) !important;\n}\n\n.fb-sim-actions {\n  border-top: 1px solid rgba(15, 23, 42, 0.07);\n  background: #f8fafc;\n}\n\n.fb-sim-restart-btn {\n  text-transform: none !important;\n  font-weight: 600 !important;\n}\n\n.fb-sim-empty-state {\n  height: 100%;\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: rgba(15, 23, 42, 0.65);\n  font-size: 14px;\n  font-weight: 600;\n  padding: 0 20px;\n}\n\n/* Hide on small screens */\n@media (max-width: 980px) {\n  .flowbuilder-sidebar {\n    display: none;\n  }\n\n  .flowbuilder-mobile-fab {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* =========================================================\n   Nodes (Premium) - used by message/menu/openai nodes\n   ========================================================= */\n.fb-node{\n  width: 250px;\n  position: relative;\n\n  background: rgba(255,255,255,0.96);\n  border: 1px solid rgba(17, 24, 39, 0.10);\n  border-radius: 16px;\n  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.10);\n\n  padding: 12px;\n  transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease;\n\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, \"Segoe UI\", Roboto,\n    Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif;\n}\n\n.fb-node:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 18px 46px rgba(16, 24, 40, 0.14);\n  border-color: rgba(99, 102, 241, 0.28);\n}\n\n.react-flow__node.selected .fb-node{\n  outline: 2px solid rgba(99, 102, 241, 0.28);\n  outline-offset: 2px;\n}\n\n.fb-node__header{\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding-right: 56px;\n  margin-bottom: 8px;\n}\n\n.fb-node__chip{\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  border-radius: 999px;\n\n  background: rgba(99, 102, 241, 0.10);\n  border: 1px solid rgba(99, 102, 241, 0.18);\n  color: #0f172a;\n  font-size: 13px;\n  font-weight: 600; /* lighter */\n}\n\n.fb-node__body{\n  color: rgba(15, 23, 42, 0.75);\n  font-size: 12.5px;\n  line-height: 1.35;\n  padding-right: 6px;\n}\n\n/* Actions (top-right) */\n.fb-node__actions{\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  display: flex;\n  gap: 6px;\n}\n\n.fb-iconbtn{\n  width: 30px;\n  height: 30px;\n  border-radius: 10px;\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  background: rgba(255,255,255,0.92);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: rgba(15, 23, 42, 0.55);\n  transition: background 120ms ease, transform 120ms ease, color 120ms ease,\n    border-color 120ms ease;\n}\n\n.fb-iconbtn:hover{\n  background: #ffffff;\n  color: rgba(15, 23, 42, 0.80);\n  border-color: rgba(99, 102, 241, 0.22);\n  transform: translateY(-1px);\n}\n\n/* Handles */\n.fb-handle{\n  width: 18px !important;\n  height: 18px !important;\n  border-radius: 999px !important;\n  background: #6366F1 !important;\n  border: 2px solid #ffffff !important;\n  box-shadow: 0 10px 22px rgba(99, 102, 241, 0.28);\n  cursor: pointer;\n}\n\n.fb-handle__arrow{\n  color: #ffffff;\n  width: 10px;\n  height: 10px;\n  margin-left: 4px;\n  margin-bottom: 1px;\n  pointer-events: none;\n}\n\n\n/* =========================================================\n   Workspace alignment (Sidebar + Canvas)\n   ========================================================= */\n.fb-workspace{\n  align-items: stretch;\n  gap: 10px;\n  min-height: 75vh;\n}\n\n/* Ensure canvas and sidebar share the same vertical span */\n.flow-canvas-container{\n  border-radius: 14px;\n  border: 1px solid rgba(17, 24, 39, 0.06);\n  box-shadow: 0 10px 26px rgba(16, 24, 40, 0.06);\n  overflow: hidden;\n}\n\n/* =========================================================\n   Header polish (Title + Buttons)\n   ========================================================= */\n.fb-headerbar{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(17, 24, 39, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);\n}\n\n.fb-header-left{\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.fb-header-left > *:first-child{\n  /* Title component */\n  margin: 0;\n}\n\n.fb-header-subtitle{\n  font-size: 12px;\n  font-weight: 400;\n  color: rgba(15, 23, 42, 0.62);\n}\n\n.fb-header-actions{\n  display: flex;\n  gap: 8px;\n}\n\n/* Buttons (Material-UI v4) */\n.fb-header-btn{\n  border-radius: 10px !important;\n  padding: 7px 12px !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  letter-spacing: 0 !important;\n  box-shadow: 0 8px 16px rgba(16, 24, 40, 0.10) !important;\n  transition: transform 120ms ease, box-shadow 120ms ease, filter 120ms ease !important;\n}\n\n.fb-header-btn:hover{\n  transform: translateY(-1px);\n  box-shadow: 0 10px 22px rgba(16, 24, 40, 0.14) !important;\n  filter: brightness(1.02);\n}\n\n@media (max-width: 1160px) {\n  .fb-headerbar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .fb-header-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n}\n\n/* Optional: color accents without changing your theme primary */\n.fb-btn-import{ }\n.fb-btn-export{ }\n.fb-btn-save{ }\n\n/* =========================================================\n   Part 2 - Node Compact System (SaaS)\n   ========================================================= */\n.react-flow__node-message > div,\n.react-flow__node-menu > div,\n.react-flow__node-interval > div,\n.react-flow__node-img > div,\n.react-flow__node-audio > div,\n.react-flow__node-video > div,\n.react-flow__node-randomizer > div,\n.react-flow__node-singleBlock > div,\n.react-flow__node-ticket > div,\n.react-flow__node-typebot > div,\n.react-flow__node-openai > div,\n.react-flow__node-question > div,\n.react-flow__node-start > div {\n  padding: 10px !important;\n  border-radius: 12px !important;\n  border: 1px solid rgba(15, 23, 42, 0.1) !important;\n  box-shadow: 0 8px 20px rgba(16, 24, 40, 0.09) !important;\n  transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease !important;\n}\n\n.react-flow__node-message > div:hover,\n.react-flow__node-menu > div:hover,\n.react-flow__node-interval > div:hover,\n.react-flow__node-img > div:hover,\n.react-flow__node-audio > div:hover,\n.react-flow__node-video > div:hover,\n.react-flow__node-randomizer > div:hover,\n.react-flow__node-singleBlock > div:hover,\n.react-flow__node-ticket > div:hover,\n.react-flow__node-typebot > div:hover,\n.react-flow__node-openai > div:hover,\n.react-flow__node-question > div:hover,\n.react-flow__node-start > div:hover {\n  transform: translateY(-1px);\n  border-color: rgba(99, 102, 241, 0.26) !important;\n  box-shadow: 0 12px 26px rgba(16, 24, 40, 0.12) !important;\n}\n\n.react-flow__node-message > div,\n.react-flow__node-menu > div,\n.react-flow__node-interval > div,\n.react-flow__node-randomizer > div,\n.react-flow__node-ticket > div,\n.react-flow__node-typebot > div,\n.react-flow__node-openai > div,\n.react-flow__node-question > div,\n.react-flow__node-start > div {\n  width: 200px !important;\n}\n\n.react-flow__node-singleBlock > div,\n.react-flow__node-img > div,\n.react-flow__node-audio > div,\n.react-flow__node-video > div {\n  width: 220px !important;\n}\n\n.react-flow__node-message > div .MuiSvgIcon-root,\n.react-flow__node-menu > div .MuiSvgIcon-root,\n.react-flow__node-interval > div .MuiSvgIcon-root,\n.react-flow__node-img > div .MuiSvgIcon-root,\n.react-flow__node-audio > div .MuiSvgIcon-root,\n.react-flow__node-video > div .MuiSvgIcon-root,\n.react-flow__node-randomizer > div .MuiSvgIcon-root,\n.react-flow__node-singleBlock > div .MuiSvgIcon-root,\n.react-flow__node-ticket > div .MuiSvgIcon-root,\n.react-flow__node-typebot > div .MuiSvgIcon-root,\n.react-flow__node-openai > div .MuiSvgIcon-root,\n.react-flow__node-question > div .MuiSvgIcon-root,\n.react-flow__node-start > div .MuiSvgIcon-root {\n  width: 15px;\n  height: 15px;\n}\n\n.react-flow__node-message > div [style*=\"fontSize: 14\"],\n.react-flow__node-menu > div [style*=\"fontSize: 14\"],\n.react-flow__node-interval > div [style*=\"fontSize: 14\"],\n.react-flow__node-randomizer > div [style*=\"fontSize: 14\"],\n.react-flow__node-singleBlock > div [style*=\"fontSize: 14\"],\n.react-flow__node-ticket > div [style*=\"fontSize: 14\"],\n.react-flow__node-typebot > div [style*=\"fontSize: 14\"],\n.react-flow__node-openai > div [style*=\"fontSize: 14\"],\n.react-flow__node-question > div [style*=\"fontSize: 14\"],\n.react-flow__node-start > div [style*=\"fontSize: 14\"] {\n  font-size: 13px !important;\n}\n\n.react-flow__node-message > div [style*=\"fontSize: 12\"],\n.react-flow__node-menu > div [style*=\"fontSize: 12\"],\n.react-flow__node-interval > div [style*=\"fontSize: 12\"],\n.react-flow__node-randomizer > div [style*=\"fontSize: 12\"],\n.react-flow__node-singleBlock > div [style*=\"fontSize: 12\"],\n.react-flow__node-ticket > div [style*=\"fontSize: 12\"],\n.react-flow__node-typebot > div [style*=\"fontSize: 12\"],\n.react-flow__node-openai > div [style*=\"fontSize: 12\"],\n.react-flow__node-question > div [style*=\"fontSize: 12\"],\n.react-flow__node-start > div [style*=\"fontSize: 12\"] {\n  font-size: 11px !important;\n}\n\n.react-flow__node-message > div .react-flow__handle,\n.react-flow__node-menu > div .react-flow__handle,\n.react-flow__node-interval > div .react-flow__handle,\n.react-flow__node-img > div .react-flow__handle,\n.react-flow__node-audio > div .react-flow__handle,\n.react-flow__node-video > div .react-flow__handle,\n.react-flow__node-randomizer > div .react-flow__handle,\n.react-flow__node-singleBlock > div .react-flow__handle,\n.react-flow__node-ticket > div .react-flow__handle,\n.react-flow__node-typebot > div .react-flow__handle,\n.react-flow__node-openai > div .react-flow__handle,\n.react-flow__node-question > div .react-flow__handle,\n.react-flow__node-start > div .react-flow__handle {\n  width: 16px !important;\n  height: 16px !important;\n  border: 2px solid #ffffff !important;\n  box-shadow: 0 8px 18px rgba(99, 102, 241, 0.24) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.react-flow__node-message > div audio,\n.react-flow__node-video > div video,\n.react-flow__node-img > div img {\n  border-radius: 10px;\n}\n\n.react-flow__node-message > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-menu > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-interval > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-img > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-audio > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-video > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-randomizer > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-singleBlock > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-ticket > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-typebot > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-openai > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-question > div .react-flow__handle .MuiSvgIcon-root,\n.react-flow__node-start > div .react-flow__handle .MuiSvgIcon-root {\n  width: 9px !important;\n  height: 9px !important;\n  margin: 0 !important;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
